import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import EditIcon from '../../../../assets/svg/edit.svg';

import { Link } from 'react-router-dom';
import { ReactComponent as CheckIcon } from '../../../../assets/svg/check_green_24px.svg';
import { ReactComponent as CloseIcon } from '../../../../assets/svg/close_red_24px.svg';
import TagsIcon from '../../../../assets/svg/tags_24px.svg';
import { getPersonAllowedSee } from '../../../../shared/db/general-db';
import { iItemsAllowed, iList, iTag, iVisibleDevicesTags, MenuPinType } from '../../../../shared/interfaces';
import LocalPersonTile from '../LocalPeopleTile';
import styles from './VisibleTagsTile.module.scss';

const VisibleTagsTile = (props: iVisibleDevicesTags) => {
  const {editUrl} = props;
  const [tags, setTags] = useState<iList<iTag>>();
  const [allowed, setAllowed] = useState<iItemsAllowed | null>(null);
  const { userCanDo, personId, isPinned, showPin } = props;
  const [collapsed, setCollapsed] = useState<boolean>(isPinned);

  useEffect(() => {
    setCollapsed(isPinned);
  }, [isPinned]);

  useEffect(() => {
    const filteredTags = Object.keys(props.tags).reduce((acc, rec) => {
      if (get(props.tags[rec], `instances.allowed-see.person.${personId}`)) {
        return {...acc, [rec]: props.tags[rec]};
      }

      return acc;
    }, {});

    const getAllowedItems = async () => {
      const data = await getPersonAllowedSee(props.personId);

      setAllowed(data);
    }

    getAllowedItems();
    setTags(filteredTags);
  }, []);

  const hideTable = (!tags || Object.keys(tags).length === 0);

  return (
    <LocalPersonTile
      collapsible
      initialCollapsed={collapsed}
      title="Visible Tags"
      action={
        editUrl ?
        <Link to={editUrl}>
          <img src={EditIcon} alt='editIcon' className={styles.editIconStyle}/>
        </Link> : null
      }
      isPinned={isPinned}
      withPin={showPin}
      property={MenuPinType.VISIBLE_TAGS}
      leftIcon={null}
      tileBodyClassName={styles.tileBody}
    >
      {(!allowed || hideTable) ? null : (
        <div className={styles.VisibleTagsTileTableContainer}>
          <table className={styles.VisibleTagsTileTable}>
            <thead>
                <tr className={styles.VisibleTagsTileHeaderRow}>
                  <th>Tag</th>
                </tr>
            </thead>
            <tbody>
            {Object.keys(tags || {}).map((filterId) => {
              const isReadOnly = get(
                tags[filterId],
                `instances.allowed-see.readOnly.${personId}`,
                false
              );
              const name = tags[filterId].details.name;
              return (
                <tr key={filterId} className={styles.VisibleTagsTileTableRow}>
                  <td>
                    {name}
                  </td>
                  {/*<td>*/}
                  {/*  {isReadOnly ? <CheckIcon style={{width: '16px', height: '16px'}}/> : <CloseIcon style={{width: '14px', height: '14px'}}/>}*/}
                  {/*</td>*/}
                </tr>
              )
            })}
            </tbody>
          </table>
        </div>
      )}
    </LocalPersonTile>
  )
}

export default VisibleTagsTile;
